import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetDefaultAssets = async (serviceOfferingID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        serviceOfferingID: serviceOfferingID,
      }).toString();

      const response = await fetch(
        `${dev_baseUrl}/Service/getDefaultAssets?${queryParams}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};

export const SaveDefaultAsset = async (serviceOfferingID, asset, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        defaultJobAssetID: asset.defaultJobAssetID || 0,
        serviceOfferingID: serviceOfferingID,
        assetID: asset.assetID,
        assetTypeID: asset.assetTypeID,
        quantity: asset.quantity,
        usageDuration: asset.usageDuration,
        costPerUnit: asset.costPerUnit,
        pricePerUnit: asset.pricePerUnit,
        markup: asset.markup
      };

      const response = await fetch(`${dev_baseUrl}/Service/saveDefaultAsset`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

export const DeleteDefaultAsset = async (defaultJobAssetID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(
        `${dev_baseUrl}/Service/deleteDefaultAsset/${defaultJobAssetID}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { isError: true, message: "Access token is missing." };
  }
};
